import { defaultTheme } from '@hrworks/design-system'

/**
 * Application theme configuration
 * Extends the SmartFace design system default theme with convenient shortcuts
 */
export const theme = {
  ...defaultTheme,
  // Add convenient shortcuts to commonly used theme properties
  colors: {
    background: {
      default: defaultTheme.sqwTier2Color.background.neutral.subtle.default,
      paper: defaultTheme.sqwTier2Color.background.neutral.subtlest.default,
      hover: defaultTheme.sqwTier2Color.background.brand.bold.hovered,
      disabled: defaultTheme.sqwTier2Color.background.disabled,
    },
    border: {
      default: defaultTheme.sqwTier2Color.border.input,
      light: defaultTheme.sqwTier2Color.border.subtle,
    },
    text: {
      primary: defaultTheme.sqwTier2Color.text.default,
      secondary: defaultTheme.sqwTier2Color.text.subtle,
      error: defaultTheme.sqwTier2Color.text.error,
      success: defaultTheme.sqwTier2Color.text.success,
      warning: defaultTheme.sqwTier2Color.text.warning,
      disabled: defaultTheme.sqwTier2Color.text.disabled,
    },
    primary: {
      main: defaultTheme.marko.colors.variant.primary.color,
      light: defaultTheme.marko.colors.variant.primary.hover,
      dark: defaultTheme.marko.colors.variant.primary.active,
      contrastText: '#ffffff',
    },
    error: {
      main: defaultTheme.marko.colors.variant.danger.color,
      light: defaultTheme.sqwTier2Color.background.error.subtle,
      dark: defaultTheme.marko.colors.variant.danger.active,
    },
    success: {
      main: defaultTheme.marko.colors.variant.success.color,
      light: defaultTheme.sqwTier2Color.background.success.subtle,
      dark: defaultTheme.marko.colors.variant.success.active,
    },
    warning: {
      main: defaultTheme.marko.colors.variant.warning.color,
      light: defaultTheme.sqwTier2Color.background.warning.subtle,
      dark: defaultTheme.marko.colors.variant.warning.active,
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
  typography: {
    h1: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    body: {
      fontSize: '1rem',
      fontWeight: 400,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400,
    },
    fontSize: {
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
    },
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1280px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
  },
} as const

export type Theme = typeof theme
